let data;
export default data = [
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1416.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1417.jpg",
        info:{
                Title:"Assisted Hyperextension",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/368.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/369.jpg",
        info:{
                Title:"Back Hyperextension",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Machine - Strength"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/3288.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/3289.jpg",
        info:{
                Title:"Back Stretch",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1596.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1597.jpg",
        info:{
                Title:"Barbell Behind the Back Shrug",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/12.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/13.jpg",
        info:{
                Title:"Barbell Bent-Over Row",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1880.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1881.jpg",
        info:{
                Title:"Barbell Clean Deadlift",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/372.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/373.jpg",
        info:{
                Title:"Barbell Good Morning",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/356.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/357.jpg",
        info:{
                Title:"Barbell Incline Bench Pull",
                group:"Main Muscle Group : Back",
                type:"Type : Strength",
                equip:"Equipment : Bench"

            },
        button:"View History",
        bg:"#f4f4f4"
    }

]